import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { topics } from "@/mocks/topics";
import { formatHeat, formatDate } from "@/utils/format";

const ranked = [...topics].sort((a, b) => b.heat - a.heat);
const lead = ranked[0];
const rest = ranked.slice(1, 6);

export default function HotTopics() {
  return (
    <section className="mx-auto w-full px-4 py-16 md:px-6 md:py-20" aria-labelledby="hot-topics-title">
      <Reveal>
        <SectionHeading
          eyebrow="热梗榜"
          title={<span id="hot-topics-title">这周大家都在追的梗</span>}
          desc="按站内热度实时排序，每一条都附上了后续进展与衍生玩法。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              查看完整榜单
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Reveal>
          <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <Link to={`/topics/${lead.id}`} className="relative block h-60 w-full overflow-hidden md:h-72">
              <img
                src={lead.cover}
                alt={`${lead.title} 配图`}
                title={`${lead.title} - 513吃瓜热梗`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 font-label text-xs text-foreground-950">
                <i className="ri-trophy-line" aria-hidden="true"></i>
                本周第 1 名
              </span>
            </Link>
            <div className="flex flex-1 flex-col p-6">
              <div className="mb-3 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-secondary-800">
                  {lead.categoryName}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
                  热度 {formatHeat(lead.heat)}
                </span>
                <span>{formatDate(lead.date)}</span>
              </div>
              <h3 className="text-xl font-medium leading-snug text-foreground-950 md:text-2xl">
                <Link to={`/topics/${lead.id}`} className="hover:text-primary-700">
                  {lead.title}
                </Link>
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
              <Link
                to={`/topics/${lead.id}`}
                className="mt-5 inline-flex items-center gap-1.5 font-label text-sm text-primary-700 hover:text-primary-600"
              >
                读全文，看后续
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </article>
        </Reveal>

        <div className="flex flex-col gap-4">
          {rest.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 70}>
              <article className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-100 font-heading text-lg text-foreground-700">
                  {index + 2}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="text-base font-medium leading-snug text-foreground-950">
                    <Link to={`/topics/${topic.id}`} className="hover:text-primary-700">
                      {topic.title}
                    </Link>
                  </h3>
                  <p className="mt-1 line-clamp-1 text-sm text-foreground-600">{topic.summary}</p>
                  <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                    <span>{topic.categoryName}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
                      {formatHeat(topic.heat)}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}